import React, { PropTypes } from 'react';
import cx from 'classnames';


export const Overlay = ({ className, show = true,...props}) => {
  return <div className={cx('g-overlay', className, { show, hide: !show })} {...props} />
}
export default Overlay;